import { useEffect, useState } from "react";

export const formatCountdown = (seconds: number) =>
	`${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;

export const useCountdown = (initialSeconds: number) => {
	const [seconds, setSeconds] = useState(initialSeconds);

	useEffect(() => {
		if (seconds <= 0) return;
		const timer = setTimeout(() => setSeconds((value) => value - 1), 1000);
		return () => clearTimeout(timer);
	}, [seconds]);

	return [seconds, setSeconds] as const;
};
